import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Router } from 'wouter';
import { Routes } from './routes/Routes.tsx';
import { ThemeProvider } from './providers/ThemeProvider.tsx';
import { ToastProvider } from '@/shared/components/Toast.tsx';
import { Analytics } from '@/shared/analytics/Analytics.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <Router>
            <Analytics />
            <Routes />
          </Router>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
